import React from "react";
import GalleryGrid from "./GalleryGrid";
import { useContent } from "../../context/ContentContext";
import { useReveal } from "../../hooks/useReveal";

export default function ProjectGallery() {
  const ref = useReveal();
  const { content } = useContent();
  const projects = content.projects || [];
  const categories = content.categories || ["All"];

  // Build gallery items (after + before shots) tagged by room type
  const items = [];
  projects.forEach((p) => {
    if (p.image) items.push({ src: p.image, category: p.category });
    if (p.before) items.push({ src: p.before, category: p.category });
  });

  if (items.length === 0) return null;

  return (
    <section className="py-20 lg:py-24 bg-white">
      <div ref={ref} className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="homi-section-tag text-homi-goldDark text-sm">Gallery</span>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl text-homi-black mt-3">
            Browse by Room Type
          </h2>
          <p className="text-homi-body mt-3">Filter the gallery and click any image to view it full-screen.</p>
        </div>
        <div className="reveal">
          <GalleryGrid items={items} categories={categories} cols={3} />
        </div>
      </div>
    </section>
  );
}
